import { useContext, useMemo } from 'react';
import { AgentProgressContext } from './context';
import type { CardState, TimelineNode } from './interfaces';
import { buildTimeline, deriveCardState, flattenNodes } from './utils.timeline';

interface AgentProgressTimelineResult {
  timeline: TimelineNode[];
  cardState: CardState | undefined;
}

export function useAgentProgressTimeline(): AgentProgressTimelineResult {
  const progress = useContext(AgentProgressContext);

  return useMemo(() => {
    if (!progress) return { timeline: [], cardState: undefined };
    const timeline = buildTimeline(progress);
    const flat = flattenNodes(timeline);
    const cardState = deriveCardState(progress, flat);
    return { timeline, cardState };
  }, [progress]);
}
